module.exports = __webpack_public_path__ + "img/3.d4f9abe8.png";